import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { SidebarComponent } from "./sidebar.component";
import { MatMenuModule } from "@angular/material/menu";
import { MatIconModule } from "@angular/material/icon";
import { MatExpansionModule } from "@angular/material/expansion";
import { SharedModule } from '../shared.module';
import { MatToolbarModule } from "@angular/material";
import { SidebarItemComponent } from './sidebar-item/sidebar-item.component';
import { DirectivesModule } from "../directives/directives.module";

@NgModule({
  imports: [
    RouterModule,
    CommonModule,
    MatMenuModule,
    MatIconModule,
    MatExpansionModule,
    SharedModule,
    MatToolbarModule,
    DirectivesModule
  ],
  declarations: [SidebarComponent, SidebarItemComponent],
  exports: [SidebarComponent],
})
export class SidebarModule {}
